import { Toast } from 'antd-mobile'
import { ExclamationCircleFill } from 'antd-mobile-icons'

/**
 * 处理表单验证错误，定位到第一个必填字段位置
 * @param {Object} error - 表单验证错误对象
 * @param {Object} options - 配置选项
 * @param {boolean} options.showToast - 是否显示Toast提示，默认true
 * @param {string} options.toastIcon - Toast图标，默认ExclamationCircleFill
 * @param {string} options.scrollBehavior - 滚动行为，默认'smooth'
 * @param {string} options.scrollBlock - 滚动位置，默认'center'
 */
export const handleFormValidationError = (error, options = {}) => {
    const {
        showToast = true,
        toastIcon = <ExclamationCircleFill />,
        scrollBehavior = 'smooth',
        scrollBlock = 'center'
    } = options

    console.error(error, '=== validation error ===')
    
    // 定位到第一个必填字段位置
    if (error.errorFields && error.errorFields.length > 0) {
        const firstErrorField = error.errorFields[0]
        const fieldName = firstErrorField.name[0]
        
        // 滚动到错误字段位置
        const errorElement = document.querySelector(`[name="${fieldName}"]`) || 
                           document.querySelector(`#${fieldName}`) ||
                           document.querySelector(`[for="${fieldName}"]`) ||
                           document.querySelector(`[data-field="${fieldName}"]`)
        
        if (errorElement) {
            errorElement.scrollIntoView({ 
                behavior: scrollBehavior, 
                block: scrollBlock 
            })
            errorElement.focus()
        }
        
        // 显示具体错误信息
        if (showToast) {
            Toast.show({
                icon: toastIcon,
                content: firstErrorField.errors[0] || `${fieldName} is required`
            })
        }

        return {
            fieldName,
            errorMessage: firstErrorField.errors[0],
            element: errorElement
        }
    }

    return null
}